import { useState, useEffect, useCallback } from "react";
import { withAppHOC } from "../../../hoc";
import PageHeading from "../../../components/PageHeader/PageHeader";
import OverlayLoader from "../../../components/OverlayLoader/OverlayLoader";
import { Grid, GridItem } from "../../../components/Grid";
import {
  FormContainer,
  Form,
  Fieldset,
  Label,
  Dropdown,
  MessageBox,
  CreateButton,
  ResetButton,
  NumberInput,
  TextInput,
} from "../../../components/FormElements";
import API from "../../../api";
import { API_RESPONSE_TYPES, PERMISSION_TYPES } from "../../../constants";
import { getReturnUrl } from "../../../utils";
import { StyledSpan } from "../../../components/Styled";

const SellerMarginsCreate = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [responseStatus, setResponseStatus] = useState("");
  const [responseMessage, setResponseMessage] = useState("");

  const [users, setUsers] = useState([]);
  const [sellerApis, setSellerApis] = useState([]);
  const [operators, setOperators] = useState([]);
  const [circles, setCircles] = useState([]);
  const [categories, setCategories] = useState([]);

  const [usersId, setUsersId] = useState("");
  const [sellerApisId, setSellerApisId] = useState("");
  const [operatorsId, setOperatorsId] = useState("");
  const [circlesId, setCirclesId] = useState("");
  const [categoriesId, setCategoriesId] = useState("");
  const [marginType, setMarginType] = useState(""); // gstWalletStatus === "Active" && isGSTSeller === "Yes" ? "GST" : "Non-GST"
  const [gstType, setGstType] = useState("");
  const [operatorCode, setOperatorCode] = useState("");
  const [amount, setAmount] = useState("");
  const [margin, setMargin] = useState("");
  const [maxLimit, setMaxLimit] = useState("");
  const [marginStatus, setMarginStatus] = useState("");

  const [disableCategory, setDisableCategory] = useState(false);
  const [disableCircle, setDisableCircle] = useState(false);

  const resetResponseData = () => {
    setIsLoading(false);
    setResponseStatus("");
    setResponseMessage("");
  };

  const resetForm = () => {
    setUsersId("");
    setSellerApisId("");
    setOperatorsId("");
    setCirclesId("");
    setCategoriesId("");
    setMarginType("");
    setGstType("");
    setOperatorCode("");
    setAmount("");
    setMargin("");
    setMaxLimit("");
    setMarginStatus("");
  };

  const readUsers = useCallback(() => {
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    API.get("/accounts-management/users?pageNumber=1&recordsPerPage=100000")
      .then((response) => {
        const { status, message, data } = response.data;
        if (status === API_RESPONSE_TYPES.FAILED) {
          setResponseStatus(status);
          setResponseMessage(message);
        } else {
          setUsers(data);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILED);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);
  

  const readSellerApis = useCallback(() => {
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    setSellerApis([]);
    API.get(
      `/recharge-configurations/seller-apis/?pageNumber=1&recordsPerPage=1000000&fUsersId=${usersId}`
    )
      .then((response) => {
        const { status, message, data, pageInfo } = response.data;
        if (status === API_RESPONSE_TYPES.FAILED) {
          setResponseStatus(status);
          setResponseMessage(message);
        } else {
          setSellerApis(data);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILED);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const readOperators = useCallback(() => {
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    API.get(
      "/recharge-configurations/operators?pageNumber=1&recordsPerPage=100000"
    )
      .then((response) => {
        const { status, message, data } = response.data;
        if (status === API_RESPONSE_TYPES.FAILED) {
          setResponseStatus(status);
          setResponseMessage(message);
        } else {
          setOperators(data);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILED);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const readCircles = useCallback(() => {
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    API.get(
      "/recharge-configurations/circles?pageNumber=1&recordsPerPage=100000"
    )
      .then((response) => {
        const { status, message, data } = response.data;
        if (status === API_RESPONSE_TYPES.FAILED) {
          setResponseStatus(status);
          setResponseMessage(message);
        } else {
          setCircles(data);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILED);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const readCategories = useCallback(() => {
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    API.get(
      `/recharge-configurations/categories/?pageNumber=1&recordsPerPage=100000`
    )
      .then((response) => {
        const { status, message, data } = response.data;
        if (status === API_RESPONSE_TYPES.FAILED) {
          setResponseStatus(status);
          setResponseMessage(message);
        } else {
          setCategories(data);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILED);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    const formData = {
      usersId,
      apisId: sellerApisId,
      operatorsId,
      circlesId,
      categoriesId,
      marginType,
      gstType,
      operatorCode,
      amount,
      margin,
      maxLimit,
      marginStatus,
    };
    API.post("/recharge-configurations/seller-margins", formData)
      .then((response) => {
        const { status, message } = response.data;
        setResponseStatus(status);
        setResponseMessage(message);
        if (status === API_RESPONSE_TYPES.SUCCESS) {
          resetForm();
          setTimeout(() => {
            resetResponseData();
            window.location.href = getReturnUrl(PERMISSION_TYPES.CREATE);
          }, 3000);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILED);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const selectCategory = useCallback(() => {
    const operator = operators?.find(
      (item) => item.id === parseInt(operatorsId)
    );
    if (operator?.rofferApplicable === "No") {
      setCategoriesId(1);
      setDisableCategory(true);
    } else {
      setCategoriesId("");
      setDisableCategory(false);
    }
    if (operator?.shouldCheckCircle === "No") {
      setCirclesId(1);
      setDisableCircle(true);
    } else {
      setCirclesId("");
      setDisableCircle(false);
    }
  }, [operatorsId]);

  useEffect(() => {
    selectCategory();
  }, [selectCategory, operatorsId]);

  useEffect(() => {
    readUsers();
    readOperators();
    readCircles();
    readCategories();
  }, [readUsers, readOperators, readCircles, readCategories]);

  useEffect(() => {
    if (usersId) {
      const user = users.find((i) => i.id?.toString() === usersId?.toString());
      setMarginType(user?.isGSTSeller === "Yes" ? "GST" : "Non-GST");
      setGstType(user?.gstType);
      readSellerApis();
    } else {
      setSellerApis([]);
      setMarginType("");
    }
  }, [readSellerApis, usersId]);

  const usersOptions = [{ title: "-- SELECT USER --", value: "" }];
  if (users && users.length > 0) {
    users.forEach(({ id, fullName, mobileNumber }) =>
      usersOptions.push({
        title: fullName,
        value: id?.toString(),
        subTitle: mobileNumber?.toString(),
      })
    );
  }

  const sellerApisOptions = [{ title: "-- SELECT API --", value: "" }];
  if (sellerApis && sellerApis.length > 0) {
    sellerApis.forEach(({ id, apiName, usersId: apiUserId }) => {
      if (apiUserId?.toString() === usersId?.toString()) {
        sellerApisOptions.push({
          title: apiName,
          value: id?.toString(),
        });
      }
    });
  }

  const operatorsOptions = [{ title: "-- SELECT OPERATOR --", value: "" }];
  if (operators && operators.length > 0) {
    operators.forEach(({ id, operatorName }) =>
      operatorsOptions.push({
        title: operatorName,
        value: id,
      })
    );
  }

  const circlesOptions = [{ title: "-- SELECT CIRCLE --", value: "" }];
  if (circles && circles.length > 0) {
    circles.forEach(({ id, circleName }) =>
      circlesOptions.push({
        title: circleName,
        value: id,
      })
    );
  }

  const categoriesOptions = [{ title: "-- SELECT CATEGORY --", value: "" }];
  if (categories && categories.length > 0) {
    categories.forEach(({ id, category }) =>
      categoriesOptions.push({
        title: category,
        value: id,
      })
    );
  }

  const marginStatuOptions = [
    {
      title: "-- SELECT MARGIN STATUS --",
      value: "",
    },
    {
      title: "Active",
      value: "Active",
    },
    {
      title: "Inactive",
      value: "Inactive",
    },
  ];

  return (
    <>
      <PageHeading {...props} />
      <FormContainer>
        <Form method="POST" action="#" onSubmit={onSubmit}>
          <Grid
            columns={
              "calc(25% - 15px) calc(25% - 15px) calc(25% - 15px) calc(25% - 15px)"
            }
          >
            <GridItem>
              <Fieldset>
                <Label required>User</Label>
                <Dropdown
                  placeholder="Please select user"
                  value={usersId}
                  onChange={setUsersId}
                  options={usersOptions}
                  disabled={isLoading}
                  searchable
                />
              </Fieldset>
            </GridItem>
            <GridItem>
              <Fieldset>
                <Label required>API</Label>
                <Dropdown
                  placeholder="Please select api"
                  value={sellerApisId}
                  onChange={setSellerApisId}
                  options={sellerApisOptions}
                  disabled={isLoading || !usersId}
                  searchable
                />
              </Fieldset>
            </GridItem>
            <GridItem>
              <Fieldset>
                <Label required>Operator</Label>
                <Dropdown
                  placeholder="Please select operator"
                  value={operatorsId}
                  onChange={setOperatorsId}
                  options={operatorsOptions}
                  disabled={isLoading || !usersId}
                  searchable
                />
              </Fieldset>
            </GridItem>
            <GridItem>
              <Fieldset>
                <Label required>Circle</Label>
                <Dropdown
                  placeholder="Please select circle"
                  value={circlesId}
                  onChange={setCirclesId}
                  options={circlesOptions}
                  disabled={isLoading || !usersId || disableCircle}
                />
              </Fieldset>
            </GridItem>
          </Grid>
          <Grid
            columns={
              "calc(33.33% - 13.33px) calc(33.33% - 13.33px) calc(33.33% - 13.33px)"
            }
          >
            <GridItem>
              <Fieldset>
                <Label required>Category</Label>
                <Dropdown
                  placeholder="Please select category"
                  value={categoriesId}
                  onChange={setCategoriesId}
                  options={categoriesOptions}
                  disabled={isLoading || !usersId || disableCategory}
                />
              </Fieldset>
            </GridItem>
            <GridItem>
              <Fieldset>
                <Label required>Operator Code</Label>
                <TextInput
                  value={operatorCode}
                  onChange={setOperatorCode}
                  placeholder="Please enter operator code"
                  maxLength={100}
                  disabled={isLoading || !usersId}
                />
              </Fieldset>
            </GridItem>
            <GridItem>
              <Fieldset>
                <Label required>Amount</Label>
                <NumberInput
                  value={amount}
                  onChange={setAmount}
                  placeholder="Please enter amount"
                  maxLength={100}
                  disabled={isLoading || !usersId}
                />
              </Fieldset>
            </GridItem>
          </Grid>
          <Grid
            columns={
              "calc(33.33% - 13.33px) calc(33.33% - 13.33px) calc(33.33% - 13.33px)"
            }
          >
            <GridItem>
              <Fieldset>
                <Label required>Margin</Label>
                <NumberInput
                  value={margin}
                  onChange={setMargin}
                  placeholder="Please enter margin"
                  maxLength={100}
                  disabled={isLoading || !usersId}
                />
              </Fieldset>
            </GridItem>
            <GridItem>
              <Fieldset>
                <Label required>Max Limit</Label>
                <NumberInput
                  value={maxLimit}
                  onChange={setMaxLimit}
                  placeholder="Please enter max limit"
                  maxLength={100}
                  disabled={isLoading || !usersId}
                />
              </Fieldset>
            </GridItem>
            <GridItem>
              <Fieldset>
                <Label required>Margin Status</Label>
                <Dropdown
                  value={marginStatus}
                  onChange={setMarginStatus}
                  placeholder="Margin Status"
                  disabled={isLoading || !usersId}
                  options={marginStatuOptions}
                />
              </Fieldset>
            </GridItem>
          </Grid>
          <Fieldset>
            <StyledSpan style={{ color: "red", fontSize: "14px" }}>
              Note: Amount should be in one of the following formats. Ex: 100,29
              ( Multiple Denominations ) OR 10-200 ( Range ) OR 299 ( Single
              Denomination ) OR 0 ( All Denominations )
            </StyledSpan>
          </Fieldset>
          {responseStatus && (
            <Fieldset>
              <MessageBox status={responseStatus} message={responseMessage} />
            </Fieldset>
          )}
          <Fieldset>
            <CreateButton disabled={isLoading} type="submit">
              Create
            </CreateButton>
            <ResetButton disabled={isLoading} type="button" onClick={resetForm}>
              Reset
            </ResetButton>
          </Fieldset>
        </Form>
        <OverlayLoader showLoader={isLoading} />
      </FormContainer>
    </>
  );
};

export default withAppHOC(SellerMarginsCreate);
